<template>
  <v-app>
    <template v-if="authed || allowUnauth">
      <topNav />
      <sideNav v-show="!navHidden" />
      <notifications />
      <createClientModal />
      <!-- THE app for vuetify context, do not use anywhere else -->
      <router-view :style="`width: calc(100vw - ${panelWidth}px)`" />
      <!-- All template contents can be found in /views -->
      <rightPanel />
      <token-manager />
      <debugModeIndicator />
      <v-overlay :dark="false" v-if="authed && !hasConfigAccess">
        <v-card>
          <h6>Unauthorized</h6>
          <p class="subtitle-1">You are not authorized for this application.</p>
          <qvoButton @click="logout">Return to Login Screen</qvoButton>
        </v-card>
      </v-overlay>
    </template>
  </v-app>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import rightPanel from "@/components/right-panel";
import sideNav from "@/components/side-nav";
import tokenManager from "@/components/token-manager";
import topNav from "@/components/top-nav";
import notifications from "@/components/notifications";
import createClientModal from "@/components/create-client-modal";
import debugModeIndicator from '@/components/debug-mode-indicator';
import qvoButton from "@/qux-common/qux22/components/molecules/button";

export default {
  components: {
    rightPanel,
    sideNav,
    tokenManager,
    topNav,
    notifications,
    createClientModal,
    debugModeIndicator,
    qvoButton,
  },
  computed: {
    ...mapState({
      loggedInUserId: (state) => state.account.loggedInUserId,
      tenantId: (state) => state.account.tenantId,
      activeTenantId: (state) => state.account.activeTenantId,
      loggedInUser: (state) => state.account.loggedInUser,
    }),
    ...mapGetters({
      panelWidth: "getTotalPanelWidth",
      navHidden: "getNavHidden",
    }),
    authed() {
      return !!this.loggedInUserId;
    },
    allowUnauth() {
      /*
					Pages that require authorization will redirect to login.
					Otherwise, the content can be viewed directly.
						Such expections must be explicitly defined here.
					This flag does NOT enable API calls / grant data access.
				*/
      let allow = false;
      if (this.$route.name === "UI Library") {
        allow = true;
      }
      return allow;
    },
    hasConfigAccess() {
      return (
        !!this.loggedInUser.accessRoles &&
        this.loggedInUser.accessRoles
          .split(",")
          .some((e) => e.startsWith("Config"))
      );
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
  },
  mounted() {
    if (this.authed) {
      this.$store.dispatch("retrieveConfigTemplate");
    }
  },
};
</script>

<style lang="scss">
html,
body,
.v-application {
  overflow: hidden;
  height: 100vh;
}

.v-application .v-application--wrap {
  display: grid;
  grid-template-rows: auto 1fr;
  grid-template-areas:
    "header header header"
    "sidenav content right-panel";
  .top-nav {
    z-index: 200;
  }
  .navigation-wrapper {
    z-index: 100;
  }
}
.qvo-color-grey-600 {
  color: $qvo-color-grey-600;
}
</style>
<style lang="scss" scoped>
.v-overlay {
  z-index: 200 !important;
  &::v-deep {
    .v-overlay__scrim {
      background-color: #000 !important;
      opacity: 0.25 !important;
    }
  }
}
.v-sheet.v-card:not(.v-sheet--outlined) {
  width: 400px;
  padding: $qvo-spacing-16 $qvo-spacing-16 $qvo-spacing-16 $qvo-spacing-24;
  box-shadow: $qvo-shadow-2;
  border-radius: 8px;
  h6 {
    margin-bottom: $qvo-spacing-24;
  }
  .subtitle-1 {
    color: $qvo-color-grey-600;
    padding-bottom: $qvo-spacing-16;
  }
}
</style>
